module.exports = __webpack_public_path__ + "img/schemeList05Display03.17ee66a6.jpg";